import { motion } from 'framer-motion'
import { HiCheckCircle } from 'react-icons/hi'
import { SectionTitle } from '@/components/SectionTitle'
import { useLanguage } from '@/i18n/LanguageContext'

export function PorQueEscolher() {
  const { t } = useLanguage()

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <SectionTitle
          title={t.porQueEscolher.title}
          subtitle={t.porQueEscolher.subtitle}
        />
        <motion.ul
          className="max-w-3xl mx-auto space-y-4"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.5 }}
        >
          {t.porQueEscolher.reasons.map((text, i) => (
            <motion.li
              key={i}
              className="flex gap-3 items-start"
              initial={{ opacity: 0, x: -10 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
            >
              <HiCheckCircle className="h-6 w-6 shrink-0 text-primary-600 mt-0.5" aria-hidden="true" />
              <span className="text-slate-700 leading-relaxed">{text}</span>
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </section>
  )
}
